import React, { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { MdStar, MdStarBorder, MdCheck } from "react-icons/md";
import "./TektimeFeedbackPage.scss";
import { API_BASE_URL } from "../Components/Apicongfig";
import CookieService from "../Components/Utils/CookieService";

function TektimeFeedback() {
  const { t } = useTranslation("global");

  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [category, setCategory] = useState("general");
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) return;

    setIsSubmitting(true);

    const token = CookieService.get("token");
    const userId = CookieService.get("user_id");

    try {
      await axios.post(
        `${API_BASE_URL}/platform-feedback`,
        {
          user_id: userId || null,
          name: name.trim() || null,
          rating,
        //   category,
          comment,
          source: "shared_feedback_link",
        },
        {
          headers: {
            Authorization: `Bearer ${token || ""}`,
          },
        }
      );
    } catch (error) {
      console.warn("Platform feedback API failed or not found.", error);
    } finally {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }
  };

  return (
    <div className="tf-page">
      <div className="tf-glow" aria-hidden="true" />

      <div className="tf-wrap">
        <div className="tf-ticket">
          {/* Stub / header half of the ticket */}
          <div className="tf-stub">
            <div className="tf-brand">
              <span className="tf-brand-mark">T</span>
              <span className="tf-brand-name">TekTIME</span>
            </div>
            <p className="tf-eyebrow">
              {t("feedbackPage.eyebrow", "Retour d'expérience")}
            </p>
            <h1 className="tf-headline">
              {t("feedbackPage.headline", "Aidez-nous à améliorer TekTime")}
            </h1>
            <p className="tf-subtext">
              {t(
                "feedbackPage.subtext",
                "Deux minutes suffisent. Votre avis façonne directement les prochaines fonctionnalités."
              )}
            </p>
          </div>

          {/* Perforated divider with ticket notches */}
          <div className="tf-perforation" role="presentation">
            <span className="tf-notch tf-notch-left" />
            <span className="tf-notch tf-notch-right" />
          </div>

          {/* Body half of the ticket */}
          <div className="tf-body">
            {isSubmitted ? (
              <div className="tf-success">
                <div className="tf-stamp">
                  <MdCheck size={34} />
                </div>
                <h2>{t("feedbackPage.thankYouTitle", "Merci !")}</h2>
                <p>
                  {t(
                    "feedbackPage.thankYouDesc",
                    "Votre retour a bien été envoyé à l'équipe TekTime."
                  )}
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} noValidate>
                <div className="tf-section">
                  <label className="tf-label" htmlFor="tf-name">
                    {t("feedbackPage.nameLabel", "Votre nom")}
                  </label>
                  <input
                    id="tf-name"
                    type="text"
                    className="tf-input"
                    placeholder={t("feedbackPage.namePlaceholder", "Entrez votre nom...")}
                    value={name}
                    onChange={(e) => setName(e.target.value.slice(0, 100))}
                    maxLength={100}
                    autoComplete="name"
                  />
                </div>

                <div className="tf-section">
                  <label className="tf-label">
                    {t("feedbackPage.rateExperience", "Comment évaluez-vous TekTime ?")}
                  </label>
                  <div className="tf-stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <button
                        key={star}
                        type="button"
                        className={`tf-star ${star <= (hoverRating || rating) ? "is-active" : ""}`}
                        onClick={() => setRating(star)}
                        onMouseEnter={() => setHoverRating(star)}
                        onMouseLeave={() => setHoverRating(0)}
                        aria-label={t("feedbackPage.starLabel", `${star} sur 5`)}
                      >
                        {star <= (hoverRating || rating) ? (
                          <MdStar size={30} />
                        ) : (
                          <MdStarBorder size={30} />
                        )}
                      </button>
                    ))}
                  </div>
                </div>

                {/* <div className="tf-section">
                  <label className="tf-label">
                    {t("feedbackPage.categoryLabel", "Catégorie")}
                  </label>
                  <div className="tf-pills">
                    {[
                      { id: "suggestion", label: t("feedbackPage.catSuggestion", "Suggestion") },
                      { id: "question", label: t("feedbackPage.catQuestion", "Question") },
                      { id: "praise", label: t("feedbackPage.catPraise", "Compliment") },
                      { id: "general", label: t("feedbackPage.catGeneral", "Général") },
                    ].map((cat) => (
                      <button
                        key={cat.id}
                        type="button"
                        className={`tf-pill ${category === cat.id ? "is-selected" : ""}`}
                        onClick={() => setCategory(cat.id)}
                      >
                        {cat.label}
                      </button>
                    ))}
                  </div>
                </div> */}

                <div className="tf-section">
                  <label className="tf-label" htmlFor="tf-comment">
                    {t("feedbackPage.commentLabel", "Un détail à partager ?")}
                  </label>
                  <div className="tf-textarea-wrap">
                    <textarea
                      id="tf-comment"
                      className="tf-textarea"
                      placeholder={t(
                        "feedbackPage.textareaPlaceholder",
                        "Ce qui vous plaît, ce qui pourrait être amélioré..."
                      )}
                      value={comment}
                      onChange={(e) => setComment(e.target.value.slice(0, 500))}
                      maxLength={500}
                      rows={4}
                    />
                    <span className="tf-char-count">{comment.length}/500</span>
                  </div>
                </div>

                <button
                  type="submit"
                  className="tf-submit"
                  disabled={rating === 0 || isSubmitting}
                >
                  {isSubmitting ? (
                    <span className="tf-spinner" />
                  ) : (
                    t("feedbackPage.submitBtn", "Envoyer mon avis")
                  )}
                </button>
              </form>
            )}
          </div>
        </div>

        <p className="tf-footer-note">
          {t("feedbackPage.footerNote", "Propulsé par")} <strong>TekTIME</strong>
        </p>
      </div>
    </div>
  );
}

export default TektimeFeedback;